import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { OktaAuth } from '@okta/okta-auth-js';
import { VrskAuthOktaService } from '@uw-verisk/auth-okta';

@Injectable()
export class AddKongInterceptor implements HttpInterceptor {
  constructor(private vrskOthService: VrskAuthOktaService) {}
 
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    console.log('AddKongInterceptor: ', request.url);
 
    // Skip interceptor for /config requests
    if (request.url.includes('/config')) {
      return next.handle(request);
    }
 
    // Return observable chain
    return this.vrskOthService.loadOktaAuth().pipe(
      switchMap((auth) => {
        const oktaAuth = new OktaAuth({
          issuer: auth.issuer,
          clientId: auth.clientId,
          redirectUri: auth.redirectUri,
          scopes: ['openid', 'profile', 'email'],
          pkce: true,
        });
 
        const accessToken = oktaAuth.getAccessToken();
 
        const authReq = accessToken
          ? request.clone({
              setHeaders: { Authorization: `Bearer ${accessToken}` },
            })
          : request;
 
        return next.handle(authReq).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              console.log('invalid access token');
 
              return from(oktaAuth.tokenManager.renew('accessToken')).pipe(
                switchMap((newAccessToken: any) => {
                  let tokenString: string;
 
                  if (typeof newAccessToken === 'string') {
                    tokenString = newAccessToken;
                  } else if (
                    newAccessToken &&
                    typeof newAccessToken.accessToken === 'string'
                  ) {
                    tokenString = newAccessToken.accessToken;
                  } else {
                    tokenString = oktaAuth.getAccessToken() || '';
                  }
 
                  if (!tokenString) {
                    oktaAuth.signOut();
                    return throwError(
                      () => new Error('Failed to renew access token')
                    );
                  }
 
                  const retryReq = request.clone({
                    setHeaders: { Authorization: `Bearer ${tokenString}` },
                  });
 
                  return next.handle(retryReq);
                }),
                catchError((refreshError) => {
                  console.error('Token renewal failed', refreshError);
                  oktaAuth.signOut();
                  return throwError(() => refreshError);
                })
              );
            }
 
            return throwError(error);
          })
        );
      })
    );
  }
}
